var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 388.33 355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "e14024bc-12e6-4c69-bf7a-51a91f37552b",
    d: "M388,83.49c1.4-3.29-1.43-6.6-8.71-6.88s-23,4.35-36.74,3.45-8.37-3.55-9.53-5.8L326.66,89.2,310.4,159.89c.19-6.27,13.88-20.21,34.8-20.49s32.74.14,32.81-5.83-13.9-12.95-13.86-14.7S387.2,101.14,388,83.49Z",
    fill: "#ffd400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2c0e232-3b91-44c5-8718-95ca4d0e0e5f",
    d: "M335.2,90.23A86.76,86.76,0,1,0,161.81,83.3a82.41,82.41,0,0,0,26.31,65.13c5.21,4.33-22.92,29.07-94.08,26.37A138.27,138.27,0,0,1,1.48,143.61L.39,175.24c-4.29,104,25.06,173.58,182.68,179.47,121.29,4.23,172.56-36.78,175.74-116.55,1.81-57.43-49.05-73-48.82-78.57A179.26,179.26,0,0,0,335.2,90.23Z",
    fill: "#b31835"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "afc29e29-0977-45df-9d50-89280323db3d",
    cx: 269.23,
    cy: 73.11,
    r: 24.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b8c16d99-e210-4d8d-9457-9f0638fdb317",
    cx: 277.23,
    cy: 73.33,
    r: 17.21,
    fill: "#232323"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanard);
export default __webpack_public_path__ + "static/media/canard.a4baad4e.svg";
export { ForwardRef as ReactComponent };